define('lib/localStorage',['require','exports','module'],function(require, exports) {
  "use strict";

  var existsStorage = function () {
      return window.Storage !== undefined;
    };

  exports.get = function (id) {
    if (existsStorage()) {
      return JSON.parse(window.localStorage.getItem(id));
    }
  };

  exports.set = function (id, data) {
    if (existsStorage()) {
      window.localStorage.setItem(id, JSON.stringify(data));
    }
  };

});

